import React from 'react';

import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Url from '../../../../../../services/Url';

import { ELanguage } from '../../../Disclosure/types';
import connectAuth, { IAuthMapStateToProps, IConnectedProps } from '../../hooks/connectAuth';

import Separator from '../../../Common/Separator';
import { IAuthState } from '../../Store/Reducers';


interface IAuthAppButtons {
    showAppButtons: boolean
    lang: string
}

type TAuthAppButtons = IConnectedProps<IAuthAppButtons>;

const Container = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: ${({ theme }) => theme.space.cat};

    > div {
        display: flex;
        gap: ${({ theme }) => theme.space.bee};

        > a {
            flex: 1;
            display: flex;
            align-items: center;

            > img {
                max-width: 100%;
            }
        }
    }

    > ${Separator} {
        margin: 0;
    }

    > span {
        color: ${({ theme }) => theme.name === 'dark' ? theme.colors.blue100 : theme.colors.gray900};
    }
`;

const langSufix: Record<string, string> = {
    [ELanguage.de]: 'de',
    [ELanguage.en]: 'en',
    [ELanguage.es]: 'es',
    [ELanguage.fr]: 'fr',
    [ELanguage.it]: 'it',
    [ELanguage.ptBr]: 'br'
};

const AuthAppButtons: React.FC<TAuthAppButtons> = ({ showAppButtons, lang }) => {
    if (!showAppButtons) return null;

    return (
        <Container data-cy="auth-app-buttons">
            <Separator />

            <FormattedMessage id="authFunctional.preferApp" />

            <div>
                <FormattedMessage id="common.appStore.play.url">
                    {(link: string) => (
                        <a
                            target="_blank"
                            data-cy="auth-app-button-play"
                            href={link} rel="noreferrer"
                        >
                            <img
                                alt="Google Play Store"
                                title="Google Play Store"
                                src={Url.image(`footer/play-store-${langSufix[lang]}.png`)}
                            />
                        </a>
                    )}
                </FormattedMessage>

                <FormattedMessage id="common.appStore.apple.url">
                    {(link: string) => (
                        <a
                            href={link}
                            data-cy="auth-app-button-apple"
                        >
                            <img
                                alt="Apple Store"
                                title="Apple Store"
                                src={Url.image(`footer/apple-store-${langSufix[lang]}.png`)}
                            />
                        </a>
                    )}
                </FormattedMessage>
            </div>
        </Container>
    );
};

const mapStateToProps: IAuthMapStateToProps<IAuthAppButtons> = (state, isComparison = false) => ((!isComparison)
    ? {
        showAppButtons: (state as IAuthState).Container.showAppButtons,
        lang: (state as IAuthState).Container.i18n.lang
    }
    : {
        showAppButtons: state.showAppButtons,
        lang: state.lang
    }
);

export default connectAuth(mapStateToProps)(AuthAppButtons);
